import { FC, useEffect } from 'react'

import Packages from 'components/event/side-menu/packages'
import { useStore } from 'components/contexts/event-page'
import { useStore as useEventPageFiltersStore } from 'components/contexts/event-page-filters'
import { GetEventAuctionByIdQuery } from 'gql'
import { Flex, NoData } from 'components/ui'
import GrantedSecure from 'components/shared/GrantedSecure'
import { useScreenClass } from 'hooks'
import { ArtistMeta } from 'types/artist'
import classNames from 'classnames'
import Details from './details'
import Tickets from './tickets'
import AfterpayMessage from '../afterpay-message'

import styles from './side-menu.module.scss'

const EventSideMenu: FC<{
  event: GetEventAuctionByIdQuery['findArtwork']
  artistMeta?: ArtistMeta
}> = ({ event, artistMeta }) => {
  const { opened } = useStore()

  const { vip } = useEventPageFiltersStore()

  const { isMobile } = useScreenClass()

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isMobile) {
      const HEADER_BANNER_HEIGHT = 137

      if (window.scrollY < HEADER_BANNER_HEIGHT) {
        document.body.style.setProperty(
          '--scroll-offset',
          `${HEADER_BANNER_HEIGHT - window.scrollY}px`
        )
      }

      document.body.style.overflow = opened ? 'hidden' : 'auto'

      return () => {
        document.body.style.overflow = 'auto'
        document.body.style.setProperty('--scroll-offset', '0px')
      }
    }
  }, [opened, isMobile])

  if (event.eventExtendedStatus === 'canceled') {
    return (
      <Flex justifyContent="center" alignItems="center" height="100%">
        <NoData description="Event was canceled" />
      </Flex>
    )
  }

  return (
    <div className={classNames(styles.side)}>
      <div className={styles.tickets}>
        {isMobile && <AfterpayMessage center />}
        {!isMobile && <GrantedSecure display="all" />}

        {vip ? (
          <Packages
            eventExtendedStatus={event.eventExtendedStatus}
            salesOnDateLocal={event.salesOnDateLocal}
            artworkSlug={event.slug}
          />
        ) : (
          <Tickets
            eventExtendedStatus={event.eventExtendedStatus}
            hideTEvoTickets={artistMeta?.hideTEvoTickets}
            eventSlug={event.slug}
            eventPk={event.pk}
          />
        )}
      </div>

      <Flex className={classNames(styles.details, { [styles.open]: opened })}>
        <Details event={event} />
      </Flex>
    </div>
  )
}

export default EventSideMenu
